import { Component, OnDestroy, OnInit } from '@angular/core';
import { UIDialogRef, UIToast, UIToastComponent, UIToastRef, UIToggle } from '@irohalab/deneb-ui';
import { BangumiProviderService } from '../../../bangumi-provider.service';
import { HttpErrorResponse } from '@angular/common/http';
import { extractMessage } from '../../../utils/error.util';
import { Subscription } from 'rxjs';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'app-import-bgm-dialog',
    imports: [
        UIToggle,
        ReactiveFormsModule
    ],
    templateUrl: './import-bgm-dialog.component.html',
    styleUrl: './import-bgm-dialog.component.less'
})
export class ImportBgmDialogComponent implements OnInit, OnDestroy {
  private subscription = new Subscription();
  private toastRef: UIToastRef<UIToastComponent>;

  importOptionForm!: FormGroup;

  constructor(private dialogRef: UIDialogRef<ImportBgmDialogComponent>,
              private bangumiProviderService: BangumiProviderService,
              private fb: FormBuilder,
              uiToast: UIToast,
  ) {
    this.toastRef = uiToast.makeText();
  }

  ngOnInit(): void {
    this.importOptionForm = this.fb.group({
      override: true,
      syncBack: true
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  close(): void {
    this.dialogRef.close(false);
  }

  import(): void {
    const override = this.importOptionForm.value.override;
    const syncBack = this.importOptionForm.value.syncBack;
    this.subscription.add(
      this.bangumiProviderService.importBgmFavorites(override, syncBack)
        .subscribe({
          next: () => {
            this.dialogRef.close(true);
          },
          error: (err: HttpErrorResponse) => {
            this.toastRef.show(extractMessage(err));
          }
        })
    );
  }
}
